import { Base } from "ui/Scripts/source/framework/base";
import { TaskRepetitionType } from "ui/Scripts/source/models/enums";

export interface ITaskListItem {
    id: string;
    name: string;
    typeCode: string;
    taskRepetitionType: TaskRepetitionType;
    stateCode: string;
    stateColor: string;
    stateSortOrder: number;
    priorityCode: string;
    prioritySortOrder: number;
    unitCode: string;
    modifyDate: number;
    handlers: string;
    removable: boolean;
    userHandler: boolean;
    locked: boolean;
    calendarTaskCount: number;
    isTitle: boolean;
    titleClass: string;
}

export class TaskListItem implements ITaskListItem {
    id: string;
    name: string;
    typeCode: string;
    taskRepetitionType: TaskRepetitionType;
    stateCode: string;
    stateColor: string;
    stateSortOrder: number;
    priorityCode: string;
    prioritySortOrder: number;
    unitCode: string;
    modifyDate: number;
    handlers: string;
    removable: boolean;
    userHandler: boolean;
    locked: boolean;
    calendarTaskCount: number;
    isTitle: boolean;
    titleClass: string;

    constructor();
    constructor(obj: ITaskListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.typeCode = obj && obj.typeCode || "";
        this.taskRepetitionType = obj && obj.taskRepetitionType || TaskRepetitionType.NotRepeated;
        this.stateCode = obj && obj.stateCode || "";
        this.stateColor = obj && obj.stateColor || "";
        this.stateSortOrder = obj && obj.stateSortOrder || 0;
        this.priorityCode = obj && obj.priorityCode || "";
        this.prioritySortOrder = obj && obj.prioritySortOrder || 0;
        this.unitCode = obj && obj.unitCode || "";
        this.modifyDate = obj && obj.modifyDate || null;
        this.handlers = obj && obj.handlers || "";
        this.removable = obj && obj.removable || false;
        this.userHandler = obj && obj.userHandler || false;
        this.locked = obj && obj.locked || false;
        this.calendarTaskCount = obj && obj.calendarTaskCount || 0;
        this.isTitle = obj && obj.isTitle || false;
        this.titleClass = obj && obj.titleClass || "";
    }

    static getTitleTaskListItem(name: string, titleClass: string): TaskListItem {
        const result = new TaskListItem();
        result.id = Base.getGuid();
        result.name = name;
        result.isTitle = true;
        result.titleClass = titleClass;
        return result;
    }
}